<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'approval.summary'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
      'button.back' | transloco
    }}</htx-button>
    <div class="panel">
      <div class="details-grid">
        <htx-data-display
          [title]="t('userDetails')"
          [icon]="'person'"
          [data]="(userDetails$ | async)!"
        ></htx-data-display>
        <htx-data-display
          [title]="t('organisationDetails')"
          [icon]="'business'"
          [data]="(organisationDetails$ | async) ?? []"
        ></htx-data-display>
      </div>

      <htx-data-container [title]="t('document')" [icon]="'description'">
        <div class="document-section">
          <htx-button variant="secondary" icon="visibility" (click)="openDocument()">{{
            t('viewDocument')
          }}</htx-button>
        </div>
      </htx-data-container>

      <htx-data-container [title]="t('decision')" [icon]="'done_all'">
        <app-admission-decision
          [approvalForm]="approvalForm"
          [admissionState$]="admissionState$"
          [existingReasoning$]="existingReasoning$"
          (approve)="approve()"
          (reject)="reject()"
        ></app-admission-decision>
      </htx-data-container>

      <htx-data-container [title]="t('comments')" [icon]="'chat'">
        @if (commentsForBox$ | async; as commentsForBox) {
          <app-comments
            [comments]="commentsForBox"
            [placeholder]="t('newComment.placeholder')"
            (commentAdded)="onCommentAdded($event)"
          ></app-comments>
        }
      </htx-data-container>
    </div>
  </div>
</app-protected-content>
